import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
   MAT_DIALOG_DATA,
   MatDialogActions,
   MatDialogClose,
   MatDialogContent,
   MatDialogRef,
   MatDialogTitle,
} from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CacheService } from '@api/custom-services/cache.service';
import { SelectEntityFieldComponent } from '@shared/components/general-selects/select-entity-field.component';
import { SubscriptionDirective } from '@shared/directives/subscriptions.directive';
import { LocalCashRegister, LocalCashRegisterService } from '@shared/services/cash-register.service';

@Component({
   selector: 'app-local-cash-register-dialog',
   imports: [
      CommonModule,
      MatButtonModule,
      MatDialogActions,
      MatDialogClose,
      MatDialogTitle,
      MatDialogContent,
      ReactiveFormsModule,
      SelectEntityFieldComponent,
      MatSlideToggleModule,
   ],
   templateUrl: './local-cash-register-dialog.component.html',
   styleUrl: './local-cash-register-dialog.component.scss',
})
export class LocalCashRegisterDialogComponent extends SubscriptionDirective {
   cashRegister!: LocalCashRegister;
   form = this.formBuilder.group({
      isDayRegister: [true],
      cashRegisterLocationId: [undefined as any as number],
   });

   constructor(
      public dialogRef: MatDialogRef<any>,
      private formBuilder: FormBuilder,
      private cacheService: CacheService,
      private localCashRegisterService: LocalCashRegisterService,
      @Inject(MAT_DIALOG_DATA) public data: any
   ) {
      super();
      this.initCashRegister();
      this.checkIfCashRegisterExist();
   }

   initCashRegister() {
      this.cashRegister = this.localCashRegisterService.getCashRegister();
      this.form.patchValue(this.cashRegister);
   }

   checkIfCashRegisterExist() {
      this.subs = this.cacheService.cashRegisterLocations$.subscribe((locations) => {
         const exist = locations.find((item) => item.id === this.cashRegister.cashRegisterLocationId);
         if (!exist) {
            this.localCashRegisterService.removeCashRegisterLocationId();
            this.initCashRegister();
         }
      });
   }

   onCancel(): void {
      this.dialogRef.close();
   }

   onSave(): void {
      this.dialogRef.close(this.form.value);
   }
}
